const BASE = process.env.REACT_APP_BACKEND_URL;

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export const apiFetch = async (path, { timeout = 15000, ...options } = {}) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(`${BASE}${path}`, { ...options, signal: controller.signal });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = typeof data.detail === "string" ? data.detail : `Request failed (${res.status})`;
      throw new ApiError(msg, res.status);
    }
    return data;
  } catch (e) {
    if (e.name === "AbortError") throw new ApiError("The request timed out. Please try again.", 0);
    throw e;
  } finally {
    clearTimeout(timer);
  }
};
